import type { ReminderEmailData } from '../../Reminder.executionSummary.hooks'
import type { Config } from '../..'

export type ReminderEmail = {
  to: string[]
  cc: string[]
  bcc: string[]
  subject: string
  body: string
}

/**
 * A completed review's output is what was (or will be) actually sent, so it
 * takes precedence over the configured template. Reviewed values are already
 * resolved by the processor, so resolving them again is a no-op.
 */
export const getReminderEmail = ({
  config,
  emailData
}: {
  config: Pick<Config, 'to' | 'cc' | 'bcc' | 'subject' | 'template'>
  emailData: ReminderEmailData
}): ReminderEmail =>
  emailData.reviewedEmail ?? {
    to: config.to,
    cc: config.cc,
    bcc: config.bcc,
    subject: config.subject,
    body: config.template
  }
